module.exports = __webpack_public_path__ + "img/5.13764b09.jpg";